// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"368":"bfc3da97","811":"8e4f4479"}[chunkId] + ".js";
};